import PubSub from "underpub-js";

var MapHotspots = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-MapHotspots',
	};

	$.extend(true, this.options, options);

};

MapHotspots.prototype.init = function() {

	var self = this;

	// Since MapHotspots doesn't have floors, we need to publish an event
	// to make all popups visible (they all have floorIndex: 1)
	// This ensures popups initialize correctly even if they load after MapHotspots
	setTimeout(function() {
		// Publish initial floor set event (using floorIndex 1 since all popups use that)
		PubSub.publish('availabilityMap:initialFloorSet', {
			floorIndex: 1
		});
		// Also publish current floor so late-initializing popups can check
		PubSub.publish('availabilityMap:currentFloor', {
			floorIndex: 1
		});
	}, 50);

};

export default MapHotspots;
